import React from 'react';
import { useParams } from "react-router-dom";
import CancelIcon from '@mui/icons-material/Cancel';
import useStyles from './styles';
const Unauthorized = () => {
    const { classes }  = useStyles();
    const { message } = useParams();
    
    return (
       
        <div className={classes.container}>
            <CancelIcon className={classes.icon} />
            <h1>Usuario no autorizado para acceder a esta página.</h1>
            <h3>Necesita permiso de acceso: <b className={classes.permission}>{message}</b></h3>
        </div>
    )
}

export default Unauthorized;